import { useEffect, useState } from 'react';
import { apiGet, apiThrow } from '../utils/api';
import { useLatestRequest } from './useSearchRequest';

/**
 * The department roles THIS caller may give in `departmentId` — the server's
 * `grantable_roles` (`GET /api/department-invites/department`). Extracted
 * 2026-11-03 from `AddPersonForm.js` so the "+ Add person" panel's search row
 * offers exactly the same list as its invite form.
 *
 * Returns `[]` while loading, with no department, or on a refusal: a 403 means
 * the caller may not ASSIGN roles there, so callers fall back to `['user']`
 * (which a settings holder may still give). Resolves no authority itself.
 */
export default function useGrantableRoles(departmentId) {
  const [grantable, setGrantable] = useState([]);
  const begin = useLatestRequest();
  useEffect(() => {
    const isCurrent = begin();
    setGrantable([]);
    if (!departmentId) return;
    (async () => {
      try {
        const res = await apiGet(`/api/department-invites/department?department_id=${departmentId}`);
        if (!res.ok) await apiThrow(res);
        const data = await res.json();
        if (isCurrent()) setGrantable(Array.isArray(data.grantable_roles) ? data.grantable_roles : []);
      } catch {
        if (isCurrent()) setGrantable([]);
      }
    })();
  }, [departmentId, begin]);
  return grantable;
}
